module.exports = __webpack_public_path__ + "img/IMG_0328_L_Black_MockedUp.d2e04c62.jpg";